export const sms_input = {
  letter_count: 'Karater: {jumlah} / {total}',
  sms_count: 'Jumlah sms: {count}'
};
